<script>
	export let realty       = {Description:''};
	export let loading      = false;
</script>
{#if !loading}
<div class="selos">
	{#if realty.Promotion02 != null && realty.Promotion02.trim().length > 0}
	<div class="selo selo-tour">
		<i class="fas fa-street-view"></i> Tour Virtual
	</div>
	{/if}

	{#if realty.Promotion03 != null && realty.Promotion03.trim().length > 0}
	<div class="selo selo-tour">
		<i class="fab fa-youtube"></i> Vídeo
	</div>
	{/if}
</div>
{/if}